module.exports = __webpack_public_path__ + "img/g-vip-dialog-bg2.242505be.png";